import { Application } from '@hotwired/stimulus';
import { registerControllers } from 'stimulus-vite-helpers';

const application = Application.start();

Object.entries(
  import.meta.glob('@controllers/main/**/*_controller.js', { eager: true })
).forEach(([path, module]) => {
  const filename = path.split('/').pop();
  const identifier = filename.split('_controller.js').shift();
  application.register(identifier, module.default);
});

// NB: Component controllers are namespaced/suffixed with `--component`
const componentsControllers = import.meta.glob(
  [
    '@components/**/*_controller.js',
    '!@components/comments/*', // Ignore all Comments-specific comments code
  ],
  { eager: true }
);
registerControllers(application, componentsControllers);
